import React, { useEffect, useState } from 'react';
import ModalBackground from '../../../shared/components/ModalBackground';
import '../../shop/styles/purchaseModal.css';
import '../styles/chestInfoModal.css';

const CLOSE_MS = 300;

/**
 * Standard bottom-sheet popup of the Cases tab (chest / key info).
 * `footer` is a render prop receiving `closeThen(cb)` — it plays the close
 * animation first and then runs cb (single timer, so onClose and the follow-up
 * action can't race each other).
 */
export default function LootboxSheet({ title, titleColor, onClose, children, footer }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => { setVisible(true); }, []);

  const closeThen = (cb) => {
    setVisible(false);
    setTimeout(() => {
      onClose();
      cb?.();
    }, CLOSE_MS);
  };

  const handleClose = () => closeThen();

  return (
    <div className="purchase-modal-overlay" onClick={handleClose}>
      <div
        className={`purchase-card ${visible ? 'visible' : ''}`}
        onClick={e => e.stopPropagation()}
      >
        <div className={`purchase-modal-sheet-ticket chest-info-sheet ${visible ? 'visible' : ''}`}>

          {/* Header with Spine animation — same pattern as TicketConverterModal */}
          <div className="purchase-modal-header" style={{ position: 'relative' }}>
            <ModalBackground />
            <h2
              className="purchase-modal-title"
              style={{ position: 'relative', zIndex: 1, color: titleColor }}
            >
              {title}
            </h2>
            <img
              className="purchase-modal-close"
              src="/close.png"
              alt="close"
              onClick={handleClose}
              style={{ position: 'absolute', zIndex: 1 }}
            />
          </div>

          <div className="chest-info-body">{children}</div>

          {footer && <div className="chest-info-footer">{footer(closeThen)}</div>}
        </div>
      </div>
    </div>
  );
}
